import { ApiResult, get } from "./api_client";
import { FishingSpotCluster, IFishingSpotCluster } from "../models";

export async function getFishingSpotGroups(zoom: number, latitude: number, longitude: number, maxLatDeviation: number, maxLonDeviation: number): ApiResult<FishingSpotCluster[]> {
	return get<IFishingSpotCluster[]>(`/api/fishingspot/grouped/${ zoom }/${ latitude }/${ longitude }/${ maxLatDeviation }/${ maxLonDeviation }`).then(result => result != undefined ? result.map(o => new FishingSpotCluster(o)) : result);
}
